import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { MatTableDataSource, MatPaginator } from '@angular/material';
import { LoadingService } from 'src/app/_services/loading.service';
import { NotificationService } from 'src/app/_services/notification.service';
import { Title } from '@angular/platform-browser';
import { DialogService } from 'src/app/_services/dialog.service';
import { CustomerService } from '../_ecomservices/customer.service';
import { CustomerPanelComponent } from '../customer-panel/customer-panel.component';

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.css']
})
export class CustomersComponent implements OnInit {

  displayedColumns: string[] = ['ID', 'name', 'mobile_number',
    'email', 'gender', 'dob', 'Action'];
  dataSource: MatTableDataSource<any>;

  constructor(public customerService: CustomerService,
    private dialog: MatDialog,
    private titleService: Title,
    private loading: LoadingService,
    private notificationService: NotificationService,
    public dialogService: DialogService,) { }

  ngOnInit() {
    this.titleService.setTitle('Customers');
    this.get_all_customers();
  }

  get_all_customers() {
    var result = this.customerService.get_all_customers().subscribe(data => {
      console.log(data);
      if (data['status']) {
        this.dataSource = new MatTableDataSource<any>(data['customers']);
      }
    });
  }

  toggleCustomerStatusChange(event: any, customerId: any) {
    let checked = event.checked;
    let status = checked ? 1 : 0;
    this.customerService.update_customer_status(customerId, status).subscribe(data => {
      console.log(data);
    });
  }

  onViewCustomerPanel(customerId: any) {
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "99%";
    matDialogConfig.position = { top: '0px' };
    matDialogConfig.data = { customerId: customerId};
    this.dialog.open(CustomerPanelComponent, matDialogConfig).afterClosed().subscribe(res => {
      // console.log(res);
      // this.onLoadOrders();
    });
  }

}
